import React, { PropsWithChildren } from 'react';
import { View, StyleProp, ViewStyle, ImageStyle, Image, useWindowDimensions, Pressable, Platform } from 'react-native';
import ButtonComponent, { enumIconButtonComponent, enumTypesButtonComponent } from './buttonComponent';
import CreateResponsiveStyle from '../utils/responsiveStyle';
export enum enumIconCardButtonComponent {
  facturacion = require('../source/icons/facturacion.png'),
  fileResult = require('../source/icons/resultados.png'),
  pdf = require('../source/icons/pdf.png'),
  xml = require('../source/icons/xml.png')
}
type SectionProps = PropsWithChildren<{
  icon: enumIconCardButtonComponent,
  styleContent?: StyleProp<ViewStyle>,
  iconButton?: enumIconButtonComponent
  typeButton: enumTypesButtonComponent,
  textButton: string,
  onPressCard?: any,
  onPressButton?: any,
  onPressIcon?:any,
  styleIcon?: StyleProp<ImageStyle>,
  styleButton?: StyleProp<ViewStyle>,
  disabledCard?: Boolean
}>;

function CardButtonComponent({ icon, styleContent, iconButton, typeButton, textButton, onPressCard, onPressButton, styleIcon, styleButton, onPressIcon, disabledCard }: SectionProps): JSX.Element {
  const layout = useWindowDimensions();
  const styles = responsiveStyle(layout);
  return (
    <Pressable disabled={disabledCard ? true : false} style={[styleContent, styles('generalContainer'), disabledCard && styles('disabled')]} onPress={() => {
      if (onPressCard && !disabledCard) {
        onPressCard();
		}
    }}>
      <View style={styles('container')}>
        <View style={[styles('itemsContainer'), styles('iconContainer')]}>
          <Pressable onPress={()=>{
            if (onPressIcon && !disabledCard) {
              onPressIcon();
            }
          }}>
            <Image style={[styles('icon'), styleIcon]} source={icon} />
          </Pressable>
        </View>
        <View style={styles('itemsContainer')}>
          <ButtonComponent
            type={typeButton}
            text={textButton}
            icon={iconButton}
            style={[ styles('button'), styleButton]}
            styleText={styles('buttonText')}
            onPressButton={() => {
					if (onPressButton && !disabledCard) {
						onPressButton();
					}
            }}
          />
        </View>
      </View>
    </Pressable>
  );
}
const responsiveStyle = CreateResponsiveStyle({
  generalContainer: {
    display: 'flex',
    ...Platform.select({
      web: {
        cursor: 'pointer',
      },
    }),
  },
  iconContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 18,
  },
  container: {
  },
  itemsContainer: {
  },
  icon: {
    width: 71,
    height: 88,
  },
  button: {
    ...Platform.select({
      web:{
        width: 250,
        height: 70,
      },
    }),
  },
  buttonText: {
    ...Platform.select({
      web:{
        maxWidth: 130,
      },
    }),
  },
  disabled:{
    opacity: 0.7,
    ...Platform.select({
      web: {
        cursor: 'default',
      },
    }),
    pointerEvents: 'none',
  },
}, {
  icon: {
    width: 52,
    height: 65,
  },
  button:{
    ...Platform.select({
      web:{
        width: 140,
        height: 55,
      },
    }),
  },
});
export default CardButtonComponent;
